/**
 * withUser
 * HOC for wrapping the provided component with UserProvider
 */

import React from 'react'

import UserProvider from './user-provider'

export default function withUser (WrappedComponent) {
  return function UserProviderHOC(props) {
    return (
      <UserProvider>
        <WrappedComponent {...props} />
      </UserProvider>
    )
  }
}
